// extracted by mini-css-extract-plugin
export default {"districtCell":"DistrictCell_districtCell__NZzEu"};